import * as React from 'react';
import { Ref, forwardRef } from 'react';
const SvgTeams = (_, ref: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 16 16"
    height={_.height}
    width={_.width}
    className={_.className}
    role={_.role}
    aria-label={_.ariaLabel}
    aria-hidden={_.ariaHidden}
    ref={ref}
  >
    <path
      fill={_.color}
      d="M4.994 8.835q1.147 0 2.066.322-.312.239-.582.516a5.5 5.5 0 0 0-1.1 1.586Q5 12.11 5 12.869q0 .066.005.131h-3.94q-.496 0-.78-.21A.67.67 0 0 1 0 12.215q0-.526.343-1.117.348-.593 1-1.1a5.4 5.4 0 0 1 1.58-.837q.923-.326 2.071-.326m6 0q1.155 0 2.077.326.924.321 1.574.836.657.51 1.006 1.1.35.593.349 1.118a.67.67 0 0 1-.284.575q-.285.21-.781.21h-7.87q-.496 0-.78-.21A.67.67 0 0 1 6 12.215q0-.526.343-1.117.348-.593 1-1.1a5.4 5.4 0 0 1 1.58-.837q.923-.326 2.071-.326M5 3q.645 0 1.19.315t.87.863q.33.542.33 1.217 0 .697-.33 1.255a2.47 2.47 0 0 1-.87.88q-.545.327-1.19.326-.645 0-1.19-.326a2.54 2.54 0 0 1-.87-.88 2.4 2.4 0 0 1-.325-1.244q0-.675.325-1.217.332-.548.876-.869A2.3 2.3 0 0 1 5 3m6 0q.645 0 1.19.315t.87.863q.33.542.33 1.217 0 .697-.33 1.255a2.5 2.5 0 0 1-.87.88q-.545.327-1.19.326-.645 0-1.19-.326a2.54 2.54 0 0 1-.87-.88 2.4 2.4 0 0 1-.325-1.244q0-.675.325-1.217.332-.548.876-.869A2.3 2.3 0 0 1 11 3"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgTeams);
export default ForwardRef;
